'use client';

// «ПОДЕЛИТЬСЯ» СТАТЬЁЙ СПРАВКИ (П21 обхода владельца 11.09.2026, круг 2). Прежде под
// текстом стояли «Соседние статьи» — две случайные по порядку; их сняли, а полезное
// действие у прочитанной статьи одно: отдать её ссылку тому, кому она нужна.
//
// Умеет браузер родной лист «Поделиться» (navigator.share — телефоны, Safari) — зовём
// его; не умеет (обычный десктоп) — кладём ссылку в буфер и говорим об этом словом
// рядом с кнопкой. Ни значков-эмодзи, ни своей разметки кнопки: контрол из набора
// (@scriptera/ui/kit), слова приходят готовыми — своих строк в компоненте нет.
import { useState } from 'react';
import { KBareButton, KButton } from '@scriptera/ui/kit';

export function HelpShare({
  /** Адрес статьи БЕЗ языка и без «?app=1»: origin подставит сам браузер. */
  path,
  label,
  copied,
  title,
  round = false,
  roundClass = 'k-round',
}: {
  path: string;
  label: string;
  /** «Ссылка скопирована» — заметка после копирования (родной лист ничего не говорит). */
  copied: string;
  /** Заголовок статьи — его показывает родной лист «Поделиться». */
  title: string;
  /** Кружок со значком в шапке листа (телефон, К39) вместо кнопки со словом. */
  round?: boolean;
  /** Класс кружка: у шапки листа — `k-round`, у шапки правого поля кабинета — её кружок
   *  (`acctbtn`, ТЗ ANIM-FIX О6). */
  roundClass?: string;
}) {
  const [said, setSaid] = useState(false);

  const share = () => {
    const url = new URL(path, window.location.origin).toString();
    const nav: Navigator & { share?: (data: { title: string; url: string }) => Promise<void> } =
      window.navigator;
    if (typeof nav.share === 'function') {
      // Человек мог закрыть лист, ничего не выбрав, — это не ошибка и говорить нечего.
      void nav.share({ title, url }).catch(() => undefined);
      return;
    }
    void window.navigator.clipboard
      ?.writeText(url)
      .then(() => {
        setSaid(true);
        window.setTimeout(() => setSaid(false), 2500);
      })
      .catch(() => undefined);
  };

  if (round) {
    return (
      <span className="help-share help-share--round">
        {said ? <span className="help-share-note">{copied}</span> : null}
        <KBareButton type="button" className={roundClass} aria-label={label} title={label} onClick={share}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M12 3v12" />
            <path d="M8 7l4-4 4 4" />
            <path d="M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8" />
          </svg>
        </KBareButton>
      </span>
    );
  }
  return (
    <span className="help-share">
      {said ? <span className="help-share-note">{copied}</span> : null}
      <KButton size="sm" onClick={share}>
        {label}
      </KButton>
    </span>
  );
}
